import React from 'react';

import { flagStyles } from '../settings';

const SvgCX = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1248px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCX;
